// import './topbarplayermapnotification.css';
import { Search } from '@material-ui/icons';
import { useContext, useRef } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { ViewPortContext } from '../../context/ViewPortContext';
import { useMediaQuery } from 'react-responsive';
import './topbarPlayerMap.css'; // Assuming you have a CSS file for styles
export default function TopbarPlayerMap({
  radius,
  setRadius,
  unit,
  setUnit,
  getPosition,
}) {
  const { player } = useContext(AuthContext);
  const { width } = useContext(ViewPortContext);

  const searchInput = useRef();

  const mobileView = useMediaQuery({
    query: '(max-width: 805px)',
  });

  return (
    <div
      className={
        mobileView
          ? 'topbarPlayerMapNotificationContainerMobile world-class-bg'
          : 'topbarPlayerMapContainer world-class-bg'
      }
    >
      <div className={mobileView ? 'topbarLeftMobile' : 'topbarPlayerMapLeft'}>
        <div
          className={
            mobileView ? 'playerMapInputsMobile' : 'playerMapInputsDesktopRow' // Changed for desktop
          }
        >
          <div className="playerMapInputGroup">
            <label className="playerMapLabel" htmlFor="radius">
              <span className="distanceSpan">Radius</span>
            </label>
            <div className="playerMapInputWrapper">
              <Search className="searchIconModern" />
              <input
                id="radius"
                type="number"
                min="1"
                max="6378"
                aria-label="Player radius"
                placeholder="Distance"
                value={radius}
                className="playerMapInput"
                onChange={(e) => {
                  setRadius(e.target.value >= 0 ? e.target.value : 0);
                }}
              />
              <span className="playerMapUnit">km/mi</span>
            </div>
          </div>
          <div className="playerMapInputGroup">
            <label className="playerMapLabel" htmlFor="unit">
              <span className="unitSpan">Units</span>
            </label>
            <div className="playerMapInputWrapper">
              <Search className="searchIconModern" />
              <input
                id="unit"
                type="search"
                autoComplete="on"
                aria-label="Units"
                placeholder="km/mi"
                value={unit}
                className="playerMapInput"
                onChange={(e) => setUnit(e.target.value)}
              />
            </div>
          </div>
        </div>
        {!getPosition && (
          <span className="locationRequiredSpan modern-warning">
            Location required
          </span>
        )}
      </div>
    </div>
  );
}
